var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 51.3224,
    cy: 51.4557,
    r: 50.8512,
    fill: "#869AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.857 44.3139C59.9883 44.3139 59.2679 43.5935 59.2679 42.7248V39.8008C59.2679 37.5761 58.3145 35.4149 56.6618 33.9106C54.988 32.385 52.8268 31.6858 50.5385 31.8977C46.7246 32.2579 43.3769 36.1565 43.3769 40.2246V42.2798C43.3769 43.1485 42.6565 43.8689 41.7878 43.8689C40.9191 43.8689 40.1987 43.1485 40.1987 42.2798V40.2034C40.1987 34.5038 44.7965 29.2492 50.2418 28.7195C53.4201 28.4229 56.4711 29.4187 58.8018 31.5587C61.1113 33.6563 62.4461 36.665 62.4461 39.8008V42.7248C62.4461 43.5935 61.7258 44.3139 60.857 44.3139Z",
    fill: "#4763E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6784 74.233H44.9656C35.1768 74.233 33.3546 69.6776 32.8885 65.2493L31.2994 52.5577C31.0663 50.2694 30.9816 46.9852 33.2063 44.5274C35.1132 42.4086 38.2702 41.3916 42.8468 41.3916H59.7972C64.395 41.3916 67.552 42.4298 69.4378 44.5274C71.6413 46.9852 71.5778 50.2694 71.3447 52.5153L69.7556 65.2493C69.2894 69.6776 67.4673 74.233 57.6784 74.233ZM42.8468 44.5698C39.2661 44.5698 36.8083 45.269 35.5582 46.6674C34.52 47.8116 34.1809 49.5702 34.4564 52.1975L36.0455 64.8891C36.4057 68.2792 37.338 71.076 44.9656 71.076H57.6784C65.3061 71.076 66.2384 68.3004 66.5986 64.9315L68.1877 52.1975C68.4631 49.6126 68.1241 47.8539 67.0859 46.6886C65.8358 45.269 63.378 44.5698 59.7972 44.5698H42.8468Z",
    fill: "#4763E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5692 53.8917C57.3827 53.8917 56.4292 52.9382 56.4292 51.7729C56.4292 50.6075 57.3827 49.6541 58.548 49.6541C59.7133 49.6541 60.6668 50.6075 60.6668 51.7729C60.6668 52.9382 59.7345 53.8917 58.5692 53.8917Z",
    fill: "#4763E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7376 53.8917C42.5511 53.8917 41.5977 52.9382 41.5977 51.7729C41.5977 50.6075 42.5511 49.6541 43.7165 49.6541C44.8818 49.6541 45.8353 50.6075 45.8353 51.7729C45.8353 52.9382 44.903 53.8917 43.7376 53.8917Z",
    fill: "#4763E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpaid);
export default __webpack_public_path__ + "static/media/Userpaid.70f3412afafdf1379ceb2d7433802ab0.svg";
export { ForwardRef as ReactComponent };